import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsGeneratorComponent } from './inputs-generator.component';
import { PipesModule } from '../../pipes/pipes.module';
import { FormUtilitiesModule } from '../../ds24-ui/form-utilities';
import { DirectivesModule } from '../../directives/directives.module';
import { VarPipeModule } from '@digistore/ds24-ui/var-pipe';
import { GeneratorInputModule } from './generator-input/generator-input.module';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';

@NgModule({
  declarations: [InputsGeneratorComponent],
  imports: [
    CommonModule,
    PipesModule,
    SanitizePipeModule,
    FormUtilitiesModule,
    DirectivesModule,
    VarPipeModule,
    GeneratorInputModule,
  ],
  exports: [InputsGeneratorComponent],
})
export class InputsGeneratorModule {}
